import { z } from 'zod';
import * as personal from '../../primitives/personal';
import * as temporal from '../../primitives/temporal';
import { maxCharMessage, NotBlankMessage, RequiredMessage } from '../../validation/messages';

const requiredPersonName = z
  .string()
  .min(1, RequiredMessage)
  .max(100, maxCharMessage(100))
  .regex(/^\s*\S[\s\S]*$/, NotBlankMessage)
  .refine((v) => !v.includes('  '), 'Must not contain double spaces');

export const personalInfoBlock = z.object({
  firstName: requiredPersonName,
  middleName: personal.middleName.schema.optional(),
  lastName: requiredPersonName,
  dateOfBirth: temporal.dateOfBirth.schema.optional(),
  genderId: z.string().optional(),
});

export type PersonalInfoBlock = z.infer<typeof personalInfoBlock>;
